module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheadc3-7d12f83c1a497fcc8565fdc1df85620f.jpg";